export const postTitleToUrl = title => `/posts/${title.toLowerCase().replace(/\W+/g, '-')}`

export const mushroomNameToUrl = name => `/mushroom/${name.replace(/ /g, '_').toLowerCase()}`
